import { ReactElement } from 'react'
import Typography from '@mui/material/Typography'
import theme from 'src/theme'

interface Props {
  title: string
}

let Subheader = ({ title }: Props): ReactElement => (
  <div
    style={{
      display: 'flex',
      alignItems: 'center',
      gap: 5,
      margin: '30px 0 10px 0',
    }}
  >
    <div
      style={{
        display: 'inline-block',
        borderBottom: `thick double ${theme.palette.primary.dark}`,
        flex: '0 0 30px',
        marginTop: 5,
      }}
    ></div>
    <Typography
      variant="h5"
      sx={{ fontFamily: 'revert', display: 'inline-block' }}
    >
      {title}
    </Typography>
    <div
      style={{
        display: 'inline-block',
        borderBottom: `thin solid ${theme.palette.primary.dark}`,
        flex: '1 1 30px',
        marginTop: 5,
      }}
    ></div>
  </div>
)

export default Subheader
